import type { Dispatch, AnyAction } from 'redux';

let dispatchRef: Dispatch<AnyAction> | null = null;

export const setReduxDispatch = (dispatch: Dispatch<AnyAction>) => {
  dispatchRef = dispatch;
};

export const getReduxDispatch = (): Dispatch<AnyAction> | null => {
  if (!dispatchRef) {
    return null;
  }
  return dispatchRef;
};
